import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import en from './en';
import ptBr from './pt-br';

i18n.use(initReactI18next).init({
  resources: {
    en,
    ptBr,
  },
  lng: 'ptBr',
  fallbackLng: 'ptBr',
  interpolation: {
    escapeValue: false,
  },
  react: {
    useSuspense: false,
  },
});

export default i18n;
